<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17Z" fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>